import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { CheckboxLabel } from "@weezevent/nacre";
import Attendee from "models/attendee";
import { toArray } from "../../../../utils/filters";

const StatusFilter = ({ value, onChange = () => {} }) => {
	const { t } = useTranslation();

	const statusArray = React.useMemo(
		() =>
			toArray(
				value instanceof Set || Array.isArray(value)
					? value
					: value && typeof value === "object"
					? value?.status
					: value
			),
		[value]
	);
	const handleStatusChange = React.useCallback(
		(statusValue, checked) => {
			if (checked) {
				onChange(
					statusArray.includes(statusValue)
						? statusArray
						: [...statusArray, statusValue]
				);
			} else {
				onChange(statusArray.filter(item => item !== statusValue));
			}
		},
		[onChange, statusArray]
	);

	return (
		<>
			<CheckboxLabel
				label={t("access.attendees.attendeesList.filters.active")}
				value={Attendee.STATUS.ACTIVE}
				checked={statusArray.includes(Attendee.STATUS.ACTIVE)}
				onChange={e =>
					handleStatusChange(Attendee.STATUS.ACTIVE, e.target.checked)
				}
			/>
			<CheckboxLabel
				label={t("access.attendees.attendeesList.filters.removed")}
				value={Attendee.STATUS.REMOVED}
				checked={statusArray.includes(Attendee.STATUS.REMOVED)}
				onChange={e =>
					handleStatusChange(
						Attendee.STATUS.REMOVED,
						e.target.checked
					)
				}
			/>
		</>
	);
};

StatusFilter.propTypes = {
	value: PropTypes.object,
	onChange: PropTypes.func
};

export default StatusFilter;
